import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const Wrapper = styled("div")(() => ({
  display: "flex",
  borderRadius: "4px",
  backgroundColor: colors.gray100,
  padding: "4px 8px",
}));

export const Icon = styled("span")(() => ({
  color: colors.gray600,
  fontFamily: "Manrope",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "16px",
  letterSpacing: "0.5px",
}));
